<template>
  <div class="col-11 pl-0 ml-0">
    <div class="pt-3 mb-5">
      <div class="mt-3">
        <v-btn large color="primary" width="200" @click="chargeModalShow()"
          >결제하기</v-btn
        >
      </div>
    </div>

    <PaymentList ref="PaymentList"></PaymentList>

    <ChargeModal ref="ChargeModal"></ChargeModal>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import PaymentList from "@/components/membership/payment/PaymentList.vue";
import ChargeModal from "@/components/membership/payment/modal/Charge.vue";
import Filters from "@/libs/membership/filters.js";
export default {
  data() {
    return {
      M,
      payment_info: {
        number_of_members: 0,
        points: {
          balance: 0,
          used: 0,
        },
      },
      tab: "tab-1",
    };
  },
  methods: {
    chargeModalShow: async function() {
      this.$refs.ChargeModal.show();
    },
  },
  components: {
    PaymentList,
    ChargeModal,
  },
  mixins: [CommonMixin],
  filters: Filters,
  mounted: async function() {
    await this.$refs.PaymentList.searchTotalPayment();
    this.$parent.serchShow();
  },
};
</script>
